import React, { useMemo } from "react";
import { Box, Heading, Stat, StatLabel, StatNumber, StatGroup, Table, Thead, Tbody, Tr, Th, Td, Badge, useColorModeValue } from "@chakra-ui/react";

function parseTestResults(testResult) {
  if (!testResult || !testResult.TestRun || !testResult.TestRun.Results) return { total: 0, passed: 0, failed: 0, skipped: 0, tests: [] };
  let results = testResult.TestRun.Results.UnitTestResult || [];
  if (!Array.isArray(results)) results = [results];
  const tests = results.map((el) => ({
    name: el.$?.testName,
    outcome: el.$?.outcome,
    duration: el.$?.duration,
  }));
  const total = tests.length;
  const passed = tests.filter((t) => t.outcome === "Passed").length;
  const failed = tests.filter((t) => t.outcome === "Failed").length;
  const skipped = tests.filter((t) => t.outcome === "Skipped").length;
  return { total, passed, failed, skipped, tests };
}

export default function TestResultsWidget({ testResult }) {
  const { total, passed, failed, skipped, tests } = useMemo(() => parseTestResults(testResult), [testResult]);
  const boxBg = useColorModeValue('white', 'gray.800');
  return (
    <Box p={4} borderWidth={1} borderRadius="lg" boxShadow="md" bg={boxBg}>
      <StatGroup mb={4}>
        <Stat>
          <StatLabel>Total</StatLabel>
          <StatNumber>{total}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Passed</StatLabel>
          <StatNumber color="green.400">{passed}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Failed</StatLabel>
          <StatNumber color="red.400">{failed}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Skipped</StatLabel>
          <StatNumber color="yellow.400">{skipped}</StatNumber>
        </Stat>
      </StatGroup>
      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            <Th>Test Name</Th>
            <Th>Outcome</Th>
            <Th>Duration</Th>
          </Tr>
        </Thead>
        <Tbody>
          {tests.map((t, i) => (
            <Tr key={i}>
              <Td>{t.name}</Td>
              <Td>
                <Badge colorScheme={t.outcome === "Passed" ? "green" : t.outcome === "Failed" ? "red" : "yellow"}>{t.outcome}</Badge>
              </Td>
              <Td>{t.duration}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
} 